/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const PassportShippingTruck = (props) => {
    const { className } = props;
    return (
        <SvgIcon className={className} viewBox="0 0 37 27">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.00135 20.1582C5.20725 20.1582 3.75488 21.6106 3.75488 23.4047C3.75488 25.1988 5.20725 26.6511 7.00135 26.6511C8.79545 26.6511 10.2478 25.1988 10.2478 23.4047C10.2478 21.6106 8.79545 20.1582 7.00135 20.1582ZM24.7674 20.1582C22.9733 20.1582 21.521 21.6106 21.521 23.4047C21.521 25.1988 22.9733 26.6511 24.7674 26.6511C26.5615 26.6511 28.0139 25.1988 28.0139 23.4047C28.0139 21.6106 26.5615 20.1582 24.7674 20.1582Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32.7941 6.15121V5.46774H36.5532V4.44254H26.9887V3.41734H32.7982V1.70867C32.7982 0.764833 32.0333 0 31.0895 0H11.9565C11.0127 0 10.2478 0.764833 10.2478 1.70867V5.46774H6.14701C4.89806 5.46774 4.02745 6.26512 3.41315 7.51814C3.41315 7.51814 1.37088 10.9192 0.337543 12.9859C0.0242875 13.6124 -0.00012207 14.6905 -0.00012207 14.6905V21.1793C-0.00012207 22.1232 0.76471 22.888 1.70855 22.888H2.42049C2.67679 20.5813 4.62955 18.7872 7.00135 18.7872C9.37314 18.7872 11.3259 20.5813 11.5822 22.888H11.9524H20.1825C20.4388 20.5813 22.3916 18.7872 24.7634 18.7872C27.1352 18.7872 29.092 20.5813 29.3442 22.888H31.0814C32.0252 22.888 32.79 22.1232 32.79 21.1793V8.20161H35.1822V7.17641H25.28V6.15121H32.7941Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.22269 14.007H2.39209L5.80943 7.85986H9.22269V14.007Z"
                fill="#E2E2E2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.00149 22.2046C7.66054 22.2046 8.19756 22.7416 8.19756 23.4007C8.19756 24.0597 7.66054 24.5967 7.00149 24.5967C6.34243 24.5967 5.80542 24.0597 5.80542 23.4007C5.80949 22.7416 6.34243 22.2046 7.00149 22.2046Z"
                fill="#E2E2E2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.7672 22.2046C25.4263 22.2046 25.9633 22.7416 25.9633 23.4007C25.9633 24.0597 25.4263 24.5967 24.7672 24.5967C24.1082 24.5967 23.5712 24.0597 23.5712 23.4007C23.5712 22.7416 24.1082 22.2046 24.7672 22.2046Z"
                fill="#E2E2E2"
            />
        </SvgIcon>
    );
};

PassportShippingTruck.defaultProps = { className: '' };

PassportShippingTruck.propTypes = { className: PropTypes.string };

export default PassportShippingTruck;
